import Heading, { HeadingSize } from '@/components/atoms/Heading';
import * as S from './styles';
import { theme } from '@/styles/theme';
import { useHomeData } from '@/hooks/useHomeData';
import ListagemTitulos from '../ListagemTitulos';
import Button from '@/components/atoms/Button';
import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';
import { useRouter } from 'next/navigation';
import { CSSProperties, useEffect } from 'react';

interface DestaquesDaSemanaProps {
  mostrarBotoes?: boolean;
  styleContainer?: CSSProperties;
  mostrarTitulo?: boolean;
  tamanhoTituloListagens?: HeadingSize;
}

export default function DestaquesDaSemana(props: DestaquesDaSemanaProps) {
  const {
    mostrarBotoes = true,
    mostrarTitulo = true,
    styleContainer = {},
    tamanhoTituloListagens = 4,
  } = props;
  const router = useRouter();
  const {
    emAltaStreaming,
    carregandoEmAltaStreaming,
    filmesEmCartaz,
    carregandoFilmesEmCartaz,
    recuperarEmAltaStreaming,
    recuperarFilmesEmCartaz,
  } = useHomeData();

  useEffect(() => {
    if (
      (emAltaStreaming == null || emAltaStreaming.length === 0) &&
      !carregandoEmAltaStreaming
    ) {
      recuperarEmAltaStreaming();
    }

    if (
      (filmesEmCartaz == null || filmesEmCartaz.length === 0) &&
      !carregandoFilmesEmCartaz
    ) {
      recuperarFilmesEmCartaz();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const BotaoVerMais = () => (
    <div>
      <Button
        $size={2}
        $variant="soft"
        $focusRing
        $highContrast={false}
        $color="neutral"
        $loading={false}
        $text="ver mais"
        $IconEnd={IconeSeta}
        $iconEndProps={{
          direcao: 'direita',
          color: theme.tokens.colors.white_contrast,
        }}
        style={{
          backgroundColor: '#FFFFFF08',
          gap: theme.spacing[2],
          padding: `${theme.spacing[1] + 2}px ${theme.spacing[4]}px`,
          borderRadius: theme.radius[9],
          fontSize: theme.typography.font.size[2],
          lineHeight: `${theme.typography.font.line_height[2]}px`,
          fontWeight: theme.typography.font.weight.bold,
          color: theme.tokens.colors.white_contrast,
        }}
        $onClick={() => router.push('/recomendados')}
      />
    </div>
  );

  return (
    <S.Container style={styleContainer}>
      {mostrarTitulo ? (
        <Heading
          $priority={2}
          $size={7}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text={'Destaques da semana'}
        />
      ) : null}
      <S.ContainerListagem>
        <S.CategoriaTitulo>
          <Heading
            $priority={3}
            $size={tamanhoTituloListagens}
            $color="neutral"
            $weight="bold"
            $align="left"
            $highContrast={true}
            $text={'Em alta no Streaming'}
          />
          {mostrarBotoes ? <BotaoVerMais /> : null}
        </S.CategoriaTitulo>
        <ListagemTitulos
          $esconderTitulo
          $titulo="Em alta no Streaming"
          $conteudos={emAltaStreaming}
          $carregandoConteudos={carregandoEmAltaStreaming}
          $paddingLeft={theme.spacing[6]}
        />
      </S.ContainerListagem>
      <S.ContainerListagem>
        <S.CategoriaTitulo>
          <Heading
            $priority={3}
            $size={tamanhoTituloListagens}
            $color="neutral"
            $weight="bold"
            $align="left"
            $highContrast={true}
            $text={'Em cartaz no Cinema'}
          />
          {mostrarBotoes ? <BotaoVerMais /> : null}
        </S.CategoriaTitulo>
        <ListagemTitulos
          $esconderTitulo
          $titulo="Em cartaz no Cinema"
          $conteudos={filmesEmCartaz}
          $carregandoConteudos={carregandoFilmesEmCartaz}
          $paddingLeft={theme.spacing[6]}
        />
      </S.ContainerListagem>
    </S.Container>
  );
}
